import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import { Button, Form, Alert } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios, { post, get } from "axios";
import { ToastContainer, toast } from "react-toastify";
import config from "../../../config";
import empty from "is-empty";
import Breadcrumbs from "../../Helper/Breadcrumbs";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
// import { Stepper, Step, StepLabel, StepButton } from "@mui/material";
import { FaCamera, FaPlus, FaTimes, FaInfoCircle } from "react-icons/fa";
import Loader from "../../Helper/Loader";

const ensureUrlProtocol = (url) => {
    if (!url) return "";
    let cleanUrl = url.trim();
    if (!/^https?:\/\//i.test(cleanUrl)) {
        return `https://${cleanUrl}`;
    }
    return cleanUrl;
};

const EventVendorForm = (props) => {
    let history = useHistory();
    let tokenKey = {
        Authorization: "Token " + sessionStorage.getItem("tokenKey"),
    };
    let propsState = props.history.location.state;
    const [form, setForm] = useState({
        // Initial form state mapping to user request structure
        step_1_category: { vendor_category: "" },
        step_2_business: {
            business_name: "", business_type: "", contact_person: "",
            mobile_number: "", email: "", website_url: "", established_year: "",
            pan_number: "", gstin: ""
        },
        step_3_bank: { account_holder: "", account_number: "", ifsc_code: "", bank_name: "" },
        step_4_location: {
            primary_city: null, primary_area: null, operating_cities: [], service_radius: "",
            destination_wedding: "", address: "", pincode: ""
        },
        step_5_service: {
            service_description: "", start_price_photo: "", start_price_photo_video: "",
            pricing_model: "", package_details: { package_name: "", package_price: "" }
        },
        step_6_media: {
            cover_image: "", portfolio_images: [], instagram_url: "",
            facebook_url: "", youtube_url: "", portfolio_videos: [""], languages: []
        },
        step_7_operations: {
            response_time: "", availability: "", gmb_url: "",
            // terms_accepted: true
        },
        step_8_operations: {
            photographer_count: "", video_services: false, photography_styles: [],
            album_quality: [], drone_photography: false, raw_files_provided: false,
            edit_turnaround_time: "", special_packages: ""
        },
        step_9_payment: { payment_terms: "" }
    });

    const [categoryOptions, setCategoryOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [allAreaOptions, setAllAreaOptions] = useState([]);
    const [filteredAreaOptions, setFilteredAreaOptions] = useState([]);
    const [editMode, setEditMode] = useState(propsState ? propsState.editMode : false);
    const [isApproved, setIsApproved] = useState(false);
    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({});

    let breadcrumbData = [
        { title: "Event Vendor", href: "/eventVendorList" },
        { title: isApproved ? "View" : (editMode ? "Edit" : "Create"), href: "#" }
    ];

    let toastAttr = {
        theme: "colored", position: "top-center", autoClose: 1000,
        hideProgressBar: true, closeOnClick: true, pauseOnHover: true,
        draggable: true, progress: undefined,
    };

    const autoGenerateAboutUs = () => {
        const { business_name, established_year } = form.step_2_business;
        const { vendor_category } = form.step_1_category;
        const { primary_city } = form.step_4_location;
        const { photography_styles } = form.step_8_operations;

        let categoryName = vendor_category;
        if (categoryOptions) {
            const cat = categoryOptions.find(c => (c.slug || c.id || c.name) === vendor_category);
            if (cat) categoryName = cat.name;
        }

        let description = `${business_name || 'Our business'} is a premier ${categoryName || 'service provider'}`;

        if (primary_city && primary_city.label) {
            description += ` based in ${primary_city.label}`;
        }

        if (established_year) {
            description += `, established in ${established_year}`;
        }

        description += ". ";

        if (vendor_category.toLowerCase() === 'photography' || vendor_category.toLowerCase() === 'photography') {
            if (photography_styles && photography_styles.length > 0) {
                const styles = photography_styles.map(s => s.label || s).join(", ");
                description += `We specialize in various photography styles including ${styles}. `;
            }
        }

        description += "We are committed to providing high-quality services and creating memorable experiences for our clients.";

        handleInput("step_5_service", "service_description", description);
    };

    const handleInput = (step, field, value) => {
        setForm(prevForm => ({
            ...prevForm,
            [step]: {
                ...prevForm[step],
                [field]: value
            }
        }));
    };

    const handlePortfolioImageChange = (index, value) => {
        const newImages = [...form.step_6_media.portfolio_images];
        newImages[index] = value;
        handleInput("step_6_media", "portfolio_images", newImages);
    };

    const addPortfolioImage = () => {
        handleInput("step_6_media", "portfolio_images", [...form.step_6_media.portfolio_images, ""]);
    };

    const removePortfolioImage = (index) => {
        setForm(prev => ({ ...prev, step_6_media: { ...prev.step_6_media, portfolio_images: prev.step_6_media.portfolio_images.filter((_, i) => i !== index) } }));
    };

    const handlePortfolioVideoChange = (index, value) => {
        const updatedUrls = [...form.step_6_media.portfolio_videos];
        updatedUrls[index] = value;
        handleInput("step_6_media", "portfolio_videos", updatedUrls);
    };

    const addPortfolioVideo = () => {
        handleInput("step_6_media", "portfolio_videos", [...form.step_6_media.portfolio_videos, ""]);
    };

    const removePortfolioVideo = (index) => {
        const updatedUrls = form.step_6_media.portfolio_videos.filter((_, i) => i !== index);
        handleInput("step_6_media", "portfolio_videos", updatedUrls.length > 0 ? updatedUrls : [""]);
    };

    const handleFileUpload = (e, section, key, index = null) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        setLoading(true);
        post(config.service + "/v2/event-vendors/media/upload/", formData, {
            headers: {
                ...tokenKey,
                "Content-Type": "multipart/form-data",
            },
        })
            .then((res) => {
                setLoading(false);
                if (res.data && res.data.url) {
                    if (index !== null) {
                        const newArray = [...form[section][key]];
                        newArray[index] = res.data.url;
                        handleInput(section, key, newArray);
                    } else {
                        handleInput(section, key, res.data.url);
                    }
                    toast.success("File uploaded successfully", toastAttr);
                } else {
                    toast.error("Upload failed: No URL returned", toastAttr);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.error("Upload error:", err);
                toast.error("File upload failed", toastAttr);
            });
    };

    const handleMultipleFileUpload = (e, section, key) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        setLoading(true);
        const uploadPromises = files.map(file => {
            const formData = new FormData();
            formData.append("file", file);
            return post(config.service + "/v2/event-vendors/media/upload/", formData, {
                headers: {
                    ...tokenKey,
                    "Content-Type": "multipart/form-data",
                },
            });
        });

        Promise.all(uploadPromises)
            .then((results) => {
                setLoading(false);
                const urls = results.map(res => res.data.url).filter(url => !!url);
                if (urls.length > 0) {
                    handleInput(section, key, [...form[section][key], ...urls]);
                    toast.success(`${urls.length} files uploaded successfully`, toastAttr);
                } else {
                    toast.error("Bulk upload failed: No URLs returned", toastAttr);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.error("Bulk upload error:", err);
                toast.error("One or more files failed to upload", toastAttr);
            });
    };

    const validateStep = (step) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\d{10}$/;
        let stepErrors = {};

        switch (step) {
            case 0:
                if (empty(form.step_1_category.vendor_category)) {
                    stepErrors.vendor_category = "Vendor Category is required";
                }
                break;
            case 1:
                const biz = form.step_2_business;
                if (empty(biz.business_name)) stepErrors.business_name = "Business Name is required";
                if (empty(biz.business_type)) stepErrors.business_type = "Business Type is required";
                if (empty(biz.contact_person)) stepErrors.contact_person = "Contact Person Name is required";
                if (empty(biz.mobile_number)) {
                    stepErrors.mobile_number = "Mobile Number is required";
                } else if (!phoneRegex.test(biz.mobile_number)) {
                    stepErrors.mobile_number = "Please enter a valid 10-digit mobile number";
                }
                if (biz.email && !emailRegex.test(biz.email)) {
                    stepErrors.email = "Please enter a valid email address";
                }
                if (biz.established_year && (biz.established_year < 1900 || biz.established_year > new Date().getFullYear())) {
                    stepErrors.established_year = "Please enter a valid established year (YYYY)";
                }
                break;
            case 2:
                break;
            case 3:
                const loc = form.step_4_location;
                if (!loc.primary_city) stepErrors.primary_city = "Primary City is required";
                if (empty(loc.address)) stepErrors.address = "Address is required";
                break;
            case 4:
                const srv = form.step_5_service;

                if (empty(srv.start_price_photo)) {
                    stepErrors.start_price_photo = "Photo Package Starting Price is required";
                } else if (srv.start_price_photo < 0) {
                    stepErrors.start_price_photo = "Starting Price cannot be negative";
                }
                if (empty(srv.start_price_photo_video)) {
                    stepErrors.start_price_photo_video = "Photo+Video Package Starting Price is required";
                } else if (srv.start_price_photo_video < 0) {
                    stepErrors.start_price_photo_video = "Starting Price cannot be negative";
                }
                break;
            case 5:
                const media = form.step_6_media;
                if (empty(media.cover_image)) stepErrors.cover_image = "Cover Image is required";
                const validImages = media.portfolio_images.filter(img => !empty(img));
                if (validImages.length < 5) {
                    stepErrors.portfolio_images = `Minimum 5 portfolio images required (currently ${validImages.length})`;
                }
                break;
            case 6:
                const ops = form.step_7_operations;
                if (empty(ops.response_time)) stepErrors.response_time = "Expected Response Time is required";
                break;
            case 7:
                break;
            case 8:
                if (empty(form.step_9_payment.payment_terms)) {
                    stepErrors.payment_terms = "Payment Terms are required";
                }
                break;
            case 9:
                if (empty(form.step_5_service.service_description)) {
                    stepErrors.service_description = "About Us is required";
                } else if (form.step_5_service.service_description.length < 50) {
                    stepErrors.service_description = "About Us must be at least 50 characters";
                }
                break;
            default:
                break;
        }
        return stepErrors;
    };

    const validateAll = () => {
        let allErrors = {};
        for (let i = 0; i <= 9; i++) {
            const stepErrors = validateStep(i);
            allErrors = { ...allErrors, ...stepErrors };
        }
        setErrors(allErrors);
        return Object.keys(allErrors).length === 0;
    };



    const saveForm = () => {
        // Validate all steps before submission
        if (!validateAll()) {
            toast.error("Please enter all the required fields", toastAttr);
            return;
        }

        setLoading(true);

        // Transform form state to match the exact JSON structure requested
        let payload = {
            category: form.step_1_category.vendor_category,

            business_name: form.step_2_business.business_name,
            business_type: form.step_2_business.business_type,
            contact_person: form.step_2_business.contact_person,
            email: form.step_2_business.email,
            website_url: ensureUrlProtocol(form.step_2_business.website_url),
            established_year: parseInt(form.step_2_business.established_year) || 0,
            pan_number: form.step_2_business.pan_number,
            gstin: form.step_2_business.gstin,
            phone_number: form.step_2_business.mobile_number,
            account_holder: form.step_3_bank.account_holder,
            account_number: form.step_3_bank.account_number,
            ifsc_code: form.step_3_bank.ifsc_code,
            bank_name: form.step_3_bank.bank_name,
            // is_destination_wedding: form.step_4_location.destination_wedding,
            primary_city_name: form.step_4_location.primary_city ? form.step_4_location.primary_city.label : "",
            primary_city: form.step_4_location.primary_city ? form.step_4_location.primary_city.value : null,
            // primary_area_name: form.step_4_location.primary_area ? form.step_4_location.primary_area.label : "",
            // primary_area: form.step_4_location.primary_area ? form.step_4_location.primary_area.value : null,
            operating_cities: form.step_4_location.operating_cities.map(c => c.value || c),
            service_radius: form.step_4_location.service_radius,
            is_destination_wedding: ['Yes', 'Domestic', 'International'].includes(form.step_4_location.destination_wedding),
            destination_wedding_location: ['Domestic', 'International'].includes(form.step_4_location.destination_wedding) ? form.step_4_location.destination_wedding : "",
            address: form.step_4_location.address,
            pincode: form.step_4_location.pincode,


            service_description: form.step_5_service.service_description,
            start_price_photo: parseFloat(form.step_5_service.start_price_photo) || 0,
            start_price_photo_video: parseFloat(form.step_5_service.start_price_photo_video) || 0,
            pricing_model: form.step_5_service.pricing_model,
            package_details: {
                package_name: form.step_5_service.package_details.package_name || "",
                package_price: form.step_5_service.package_details.package_price || ""
            },

            payment_terms: form.step_9_payment.payment_terms,

            cover_image: ensureUrlProtocol(form.step_6_media.cover_image),
            portfolio_images: form.step_6_media.portfolio_images.map(url => ensureUrlProtocol(url)),
            instagram_url: ensureUrlProtocol(form.step_6_media.instagram_url),
            facebook_url: ensureUrlProtocol(form.step_6_media.facebook_url),
            youtube_url: ensureUrlProtocol(form.step_6_media.youtube_url),
            portfolio_videos: form.step_6_media.portfolio_videos.filter(url => url.trim() !== "").map(url => ensureUrlProtocol(url)),
            languages: form.step_6_media.languages.map(l => l.value || l),

            response_time: form.step_7_operations.response_time,
            availability: form.step_7_operations.availability,
            gmb_url: ensureUrlProtocol(form.step_7_operations.gmb_url),

            form_data: {
                // Mapping step 8 operations to the form_data object in JSON
                visual_styles: form.step_8_operations.photography_styles.map(s => s.value || s),
                video_services: form.step_8_operations.video_services,
                album_quality: form.step_8_operations.album_quality.map(q => q.value || q),
                drone_photography: form.step_8_operations.drone_photography,
                number_of_photographers: parseInt(form.step_8_operations.photographer_count) || 0,
                raw_files_provided: form.step_8_operations.raw_files_provided,
                edit_turnaround_time: parseInt(form.step_8_operations.edit_turnaround_time) || 0,
                special_packages: form.step_8_operations.special_packages
            },

            terms_accepted: form.step_7_operations.terms_accepted
        };

        console.log("Form Data Submitted:", payload);

        let url = editMode
            ? config.service + "/v2/event-vendors/agent/update/" + propsState.id + "/"
            : config.service + "/v2/event-vendors/agent/create/";
        let method = editMode ? "patch" : "post";

        axios({
            url: url,
            method: method,
            headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
            data: payload
        }).then(res => {
            setLoading(false);
            toast.success("Saved successfully", toastAttr);
            setTimeout(() => history.push('/eventVendorList'), 1000);
        }).catch(err => {
            setLoading(false);
            // console.log(err.response.data);
            toast.error(err.response.data, toastAttr);
        })
    }

    useEffect(() => {
        // Fetch categories dynamically
        get(config.service + "/v2/event-vendors/meta/categories/", { headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") } })
            .then(res => {
                if (res.data) {
                    setCategoryOptions(res.data);
                }
            }).catch(err => {
                console.error("Failed to fetch categories", err);
            });

        // Fetch cities
        get(config.service + "/masters/city/", { headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") } })
            .then(res => {
                if (res.data) {
                    setCityOptions(res.data.map(c => ({ value: c.id, label: c.name })));
                }
            }).catch(err => console.error("Failed to fetch cities", err));

        // Fetch areas
        // get(config.service + "/masters/area/list/", { headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") } })
        //     .then(res => {
        //         if (res.data) {
        //             const areas = res.data.map(a => ({
        //                 value: a.id,
        //                 label: a.name,
        //                 city_id: a.city_id,
        //                 pincode: a.pincode
        //             }));
        //             setAllAreaOptions(areas);
        //         }
        //     }).catch(err => console.error("Failed to fetch areas", err));

        if (editMode && propsState.id) {
            setLoading(true);
            get(config.service + "/v2/event-vendors/agent/vendor-detail/" + propsState.id + "/", { headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") } })
                .then(res => {
                    const data = res.data;
                    const mappedForm = {
                        step_1_category: { vendor_category: data.category || "" },
                        step_2_business: {
                            business_name: data.business_name || "",
                            business_type: data.business_type || "",
                            contact_person: data.contact_person || "",
                            mobile_number: data.phone_number || "",
                            email: data.email || "",
                            website_url: data.website_url || "",
                            established_year: data.established_year || "",
                            pan_number: data.pan_number || "",
                            gstin: data.gstin || ""
                        },
                        step_3_bank: {
                            account_holder: data.account_holder || "",
                            account_number: data.account_number || "",
                            ifsc_code: data.ifsc_code || "",
                            bank_name: data.bank_name || ""
                        },
                        step_4_location: {
                            primary_city: data.primary_city ? { value: data.primary_city, label: data.primary_city_name } : null,
                            // primary_area: data.primary_area ? { value: data.primary_area, label: data.primary_area_name } : null,
                            operating_cities: Array.isArray(data.operating_cities) ? data.operating_cities.map(c => typeof c === 'object' ? c : { value: c, label: c }) : [],
                            service_radius: data.service_radius || "",
                            destination_wedding: data.destination_wedding_location || data.destination_wedding || (data.is_destination_wedding ? "Yes" : "No"),
                            address: data.address || "",
                            pincode: data.pincode || ""
                        },
                        step_5_service: {
                            service_description: data.service_description || "",
                            start_price_photo: data.start_price_photo || "",
                            start_price_photo_video: data.start_price_photo_video || "",
                            package_details: data.package_details ? {
                                package_name: data.package_details.package_name || data.package_details.gold || "",
                                package_price: data.package_details.package_price || data.package_details.platinum || ""
                            } : { package_name: "", package_price: "" }
                        },
                        step_6_media: {
                            cover_image: data.cover_image || "",
                            portfolio_images: data.portfolio_images || [],
                            instagram_url: data.instagram_url || "",
                            facebook_url: data.facebook_url || "",
                            youtube_url: data.youtube_url || "",
                            portfolio_videos: Array.isArray(data.portfolio_videos) ? data.portfolio_videos : (Array.isArray(data.youtube_urls) ? data.youtube_urls : [""]),
                            languages: Array.isArray(data.languages) ? data.languages.map(l => ({ value: l, label: l })) : []
                        },
                        step_7_operations: {
                            response_time: data.response_time || "",
                            availability: data.availability || "",
                            gmb_url: data.gmb_url || "",
                            terms_accepted: data.terms_accepted || false
                        },
                        step_8_operations: {
                            photographer_count: data.form_data ? data.form_data.number_of_photographers : "",
                            video_services: data.form_data ? data.form_data.video_services : false,
                            photography_styles: data.form_data && Array.isArray(data.form_data.photography_styles) ? data.form_data.photography_styles.map(s => ({ value: s, label: s })) : [],
                            album_quality: data.form_data && Array.isArray(data.form_data.album_quality) ? data.form_data.album_quality.map(q => ({ value: q, label: q })) : [],
                            drone_photography: data.form_data ? data.form_data.drone_photography : false,
                            raw_files_provided: data.form_data ? data.form_data.raw_files_provided : false,
                            edit_turnaround_time: data.form_data ? data.form_data.edit_turnaround_time : "",
                            special_packages: data.form_data ? data.form_data.special_packages : ""
                        },
                        step_9_payment: {
                            payment_terms: data.payment_terms || ""
                        }
                    };
                    setForm(mappedForm);
                    setIsApproved(data.status === 'MIGRATED');
                    setLoading(false);
                }).catch(err => {
                    console.log(err);
                    setLoading(false);
                    toast.error("Failed to fetch details", toastAttr);
                })
        } else {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (cityOptions.length > 0) {
            let updated = false;
            const currentPrimary = form.step_4_location.primary_city;
            const currentOperating = form.step_4_location.operating_cities;

            let newPrimary = currentPrimary;
            if (currentPrimary && currentPrimary.value && (!currentPrimary.label || currentPrimary.label === currentPrimary.value || /^\d+$/.test(currentPrimary.label))) {
                const opt = cityOptions.find(o => String(o.value) === String(currentPrimary.value));
                if (opt && opt.label !== currentPrimary.label) {
                    newPrimary = opt;
                    updated = true;
                }
            }

            let newOperating = currentOperating;
            if (Array.isArray(currentOperating) && currentOperating.length > 0) {
                newOperating = currentOperating.map(c => {
                    const val = typeof c === 'object' ? c.value : c;
                    const label = typeof c === 'object' ? c.label : c;
                    if (!label || label === val || /^\d+$/.test(label)) {
                        const opt = cityOptions.find(o => String(o.value) === String(val));
                        if (opt) {
                            updated = true;
                            return opt;
                        }
                    }
                    return typeof c === 'object' ? c : { value: c, label: c };
                });
            }

            if (updated) {
                setForm(prev => ({
                    ...prev,
                    step_4_location: {
                        ...prev.step_4_location,
                        primary_city: newPrimary,
                        operating_cities: newOperating
                    }
                }));
            }
        }
    }, [cityOptions, editMode, form.step_4_location.primary_city, form.step_4_location.operating_cities]);

    const renderStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <Row>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Vendor Category <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="select"
                                    style={{ fontSize: '14px' }}
                                    value={form.step_1_category.vendor_category}
                                    isInvalid={!!errors.vendor_category}
                                    disabled={isApproved}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const isPhotography = value.toLowerCase() === 'photography';
                                        setForm(prevForm => ({
                                            ...prevForm,
                                            step_1_category: {
                                                ...prevForm.step_1_category,
                                                vendor_category: value
                                            },
                                            ...(isPhotography ? {
                                                step_8_operations: {
                                                    ...prevForm.step_8_operations,
                                                    drone_photography: true,
                                                    video_services: true,
                                                    raw_files_provided: true
                                                }
                                            } : {})
                                        }));
                                        if (errors.vendor_category) setErrors(prev => ({ ...prev, vendor_category: null }));
                                    }}>
                                    <option value="">Select</option>
                                    {categoryOptions && categoryOptions.map((cat, index) => (
                                        <option key={index} value={cat.slug || cat.id || cat.name}>{cat.name || cat.slug || cat}</option>
                                    ))}
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">{errors.vendor_category}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                );
            case 1:
                return (
                    <Row>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Business Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={form.step_2_business.business_name}
                                    isInvalid={!!errors.business_name}
                                    disabled={isApproved}
                                    onChange={e => {
                                        handleInput("step_2_business", "business_name", e.target.value);
                                        if (errors.business_name) setErrors(prev => ({ ...prev, business_name: null }));
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{errors.business_name}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Business Type <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="select"
                                    className="form-control"
                                    style={{ fontSize: '12px' }}
                                    value={form.step_2_business.business_type}
                                    isInvalid={!!errors.business_type}
                                    disabled={isApproved}
                                    onChange={e => {
                                        handleInput("step_2_business", "business_type", e.target.value);
                                        if (errors.business_type) setErrors(prev => ({ ...prev, business_type: null }));
                                    }}>
                                    <option value="">Select</option>
                                    <option value="Individual">Individual</option>
                                    <option value="Partnership">Partnership</option>
                                    <option value="Company">Company</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">{errors.business_type}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Contact Person <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={form.step_2_business.contact_person}
                                    isInvalid={!!errors.contact_person}
                                    disabled={isApproved}
                                    onChange={e => {
                                        handleInput("step_2_business", "contact_person", e.target.value);
                                        if (errors.contact_person) setErrors(prev => ({ ...prev, contact_person: null }));
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{errors.contact_person}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Mobile Number <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="tel"
                                    value={form.step_2_business.mobile_number}
                                    isInvalid={!!errors.mobile_number}
                                    disabled={isApproved}
                                    onChange={e => {
                                        handleInput("step_2_business", "mobile_number", e.target.value.replace(/\D/g, ''));
                                        if (errors.mobile_number) setErrors(prev => ({ ...prev, mobile_number: null }));
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{errors.mobile_number}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    value={form.step_2_business.email}
                                    isInvalid={!!errors.email}
                                    disabled={isApproved}
                                    onChange={e => {
                                        handleInput("step_2_business", "email", e.target.value);
                                        if (errors.email) setErrors(prev => ({ ...prev, email: null }));
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3"><Form.Group><Form.Label>Website URL</Form.Label><Form.Control type="text" value={form.step_2_business.website_url} disabled={isApproved} onChange={e => handleInput("step_2_business", "website_url", e.target.value)} /></Form.Group></Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Year Established</Form.Label>
                                <Form.Control
                                    type="number"
                                    min="1900"
                                    value={form.step_2_business.established_year}
                                    isInvalid={!!errors.established_year}
                                    disabled={isApproved}
                                    onChange={e => {
                                        handleInput("step_2_business", "established_year", Math.max(0, parseInt(e.target.value) || ""));
                                        if (errors.established_year) setErrors(prev => ({ ...prev, established_year: null }));
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{errors.established_year}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3"><Form.Group><Form.Label>PAN Number</Form.Label><Form.Control type="text" value={form.step_2_business.pan_number} disabled={isApproved} onChange={e => handleInput("step_2_business", "pan_number", e.target.value)} /></Form.Group></Col>
                        <Col md={6} className="mt-3"><Form.Group><Form.Label>GSTIN</Form.Label><Form.Control type="text" value={form.step_2_business.gstin} disabled={isApproved} onChange={e => handleInput("step_2_business", "gstin", e.target.value)} /></Form.Group></Col>
                    </Row>
                );
            case 2:
                return (
                    <Row>
                        <Col md={6} className="mt-3"><Form.Group><Form.Label>Account Holder Name</Form.Label><Form.Control type="text" value={form.step_3_bank.account_holder} disabled={isApproved} onChange={e => handleInput("step_3_bank", "account_holder", e.target.value)} /></Form.Group></Col>
                        <Col md={6} className="mt-3"><Form.Group><Form.Label>Account Number</Form.Label><Form.Control type="number" value={form.step_3_bank.account_number} disabled={isApproved} onChange={e => handleInput("step_3_bank", "account_number", e.target.value)} /></Form.Group></Col>
                        <Col md={6} className="mt-3"><Form.Group><Form.Label>IFSC Code</Form.Label><Form.Control type="text" value={form.step_3_bank.ifsc_code} disabled={isApproved} onChange={e => handleInput("step_3_bank", "ifsc_code", e.target.value)} /></Form.Group></Col>
                        <Col md={6} className="mt-3"><Form.Group><Form.Label>Bank Name</Form.Label><Form.Control type="text" value={form.step_3_bank.bank_name} disabled={isApproved} onChange={e => handleInput("step_3_bank", "bank_name", e.target.value)} /></Form.Group></Col>
                    </Row>
                );
            case 3:
                return (
                    <Row>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Primary City <span className="text-danger">*</span></Form.Label>
                                <CreatableSelect
                                    placeholder="Select or type City"
                                    options={cityOptions}
                                    value={form.step_4_location.primary_city}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            borderColor: errors.primary_city ? '#dc3545' : base.borderColor,
                                            '&:hover': {
                                                borderColor: errors.primary_city ? '#dc3545' : base.borderColor
                                            }
                                        })
                                    }}
                                    isDisabled={isApproved}
                                    onChange={(selected) => {
                                        handleInput("step_4_location", "primary_city", selected);
                                        handleInput("step_4_location", "primary_area", null);
                                        if (selected) {
                                            const filtered = allAreaOptions.filter(a => a.city_id === selected.value);
                                            setFilteredAreaOptions(filtered);
                                        } else {
                                            setFilteredAreaOptions([]);
                                        }
                                        if (errors.primary_city) setErrors(prev => ({ ...prev, primary_city: null }));
                                    }}
                                    isClearable
                                    formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                />
                                {errors.primary_city && <div className="text-danger small mt-1">{errors.primary_city}</div>}
                            </Form.Group>
                        </Col>


                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Operating Cities</Form.Label>
                                <CreatableSelect
                                    isMulti
                                    placeholder="Select or type Cities"
                                    options={cityOptions}
                                    value={form.step_4_location.operating_cities}
                                    isDisabled={isApproved}
                                    onChange={(selected) => handleInput("step_4_location", "operating_cities", selected)}
                                    formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3"><Form.Group><Form.Label>Service Radius</Form.Label><Form.Control type="text" value={form.step_4_location.service_radius} disabled={isApproved} onChange={e => handleInput("step_4_location", "service_radius", e.target.value)} /></Form.Group></Col>
                        <Col md={3} className="mt-3">
                            <Form.Group>
                                <Form.Label>Destination Wedding</Form.Label>
                                <Form.Control as="select" value={form.step_4_location.destination_wedding ? (['Domestic', 'International'].includes(form.step_4_location.destination_wedding) ? 'Yes' : form.step_4_location.destination_wedding) : ''} disabled={isApproved} onChange={e => {
                                    handleInput("step_4_location", "destination_wedding", e.target.value);
                                }}>
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        {['Yes', 'Domestic', 'International'].includes(form.step_4_location.destination_wedding) && (
                            <Col md={3} className="mt-3">
                                <Form.Group>
                                    <Form.Label>Wedding Type</Form.Label>
                                    <Form.Control as="select" value={['Domestic', 'International'].includes(form.step_4_location.destination_wedding) ? form.step_4_location.destination_wedding : ''} disabled={isApproved} onChange={e => handleInput("step_4_location", "destination_wedding", e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="Domestic">Domestic</option>
                                        <option value="International">International</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                        )}
                        <Col md={6} className="mt-3"><Form.Group><Form.Label>Pincode</Form.Label><Form.Control type="text" value={form.step_4_location.pincode} disabled={isApproved} onChange={e => handleInput("step_4_location", "pincode", e.target.value)} /></Form.Group></Col>
                        <Col md={12} className="mt-3">
                            <Form.Group>
                                <Form.Label>Address <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={form.step_4_location.address}
                                    isInvalid={!!errors.address}
                                    disabled={isApproved}
                                    onChange={e => {
                                        handleInput("step_4_location", "address", e.target.value);
                                        if (errors.address) setErrors(prev => ({ ...prev, address: null }));
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{errors.address}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                );
            case 4:
                return (
                    <Row>

                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Photo Package Starting Price <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="number"
                                    min="0"
                                    value={form.step_5_service.start_price_photo}
                                    isInvalid={!!errors.start_price_photo}
                                    disabled={isApproved}
                                    onChange={e => {
                                        const val = parseFloat(e.target.value);
                                        handleInput("step_5_service", "start_price_photo", isNaN(val) ? "" : Math.max(0, val));
                                        if (errors.start_price_photo) setErrors(prev => ({ ...prev, start_price_photo: null }));
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{errors.start_price_photo}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Photo + Video Package Starting Price <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="number"
                                    min="0"
                                    value={form.step_5_service.start_price_photo_video}
                                    isInvalid={!!errors.start_price_photo_video}
                                    disabled={isApproved}
                                    onChange={e => {
                                        const val = parseFloat(e.target.value);
                                        handleInput("step_5_service", "start_price_photo_video", isNaN(val) ? "" : Math.max(0, val));
                                        if (errors.start_price_photo_video) setErrors(prev => ({ ...prev, start_price_photo_video: null }));
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{errors.start_price_photo_video}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Pricing Model</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={form.step_5_service.pricing_model}
                                    disabled={isApproved}
                                    onChange={e => handleInput("step_5_service", "pricing_model", e.target.value)}
                                >
                                    <option value="">Select</option>
                                    <option value="Fixed">Fixed</option>
                                    <option value="Negotiable">Negotiable</option>
                                    <option value="Custom">Custom</option>
                                    <option value="Package">Package</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>

                        {/* Package Details JSON Editor / Simplified Inputs */}
                        <Col md={6} className="mt-3"><Form.Group><Form.Label> Package Name</Form.Label><Form.Control type="text" value={form.step_5_service.package_details.package_name} disabled={isApproved} onChange={e => handleInput("step_5_service", "package_details", { ...form.step_5_service.package_details, package_name: e.target.value })} /></Form.Group></Col>
                        <Col md={6} className="mt-3"><Form.Group><Form.Label> Package Price</Form.Label><Form.Control type="text" value={form.step_5_service.package_details.package_price} disabled={isApproved} onChange={e => handleInput("step_5_service", "package_details", { ...form.step_5_service.package_details, package_price: e.target.value })} /></Form.Group></Col>
                    </Row>
                );
            case 5:
                return (
                    <Row>
                        <Col md={12} className="mt-3">
                            <Form.Label>Cover Image <span className="text-danger">*</span></Form.Label>
                            <div className="d-flex align-items-center mb-1">
                                <label className="m-0 p-0" style={{ cursor: "pointer" }}>
                                    <div className="border rounded d-flex align-items-center justify-content-center bg-light" style={{ width: "120px", height: "120px", overflow: "hidden", position: "relative", borderColor: errors.cover_image ? '#dc3545' : '' }}>
                                        {form.step_6_media.cover_image ? (
                                            <>
                                                <img
                                                    src={form.step_6_media.cover_image}
                                                    alt="Cover"
                                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                />
                                                <div className="position-absolute" style={{ bottom: "5px", right: "5px", background: "rgba(0,0,0,0.5)", borderRadius: "50%", padding: "5px" }}>
                                                    <FaCamera color="#fff" size={14} />
                                                </div>
                                            </>
                                        ) : (
                                            <div className="text-center text-muted">
                                                <FaCamera size={30} className="mb-1" />
                                                <div className="small">Add Cover</div>
                                            </div>
                                        )}
                                        <Form.Control
                                            type="file"
                                            onChange={(e) => {
                                                if (isApproved) return;
                                                handleFileUpload(e, "step_6_media", "cover_image");
                                                if (errors.cover_image) setErrors(prev => ({ ...prev, cover_image: null }));
                                            }}
                                            accept="image/*"
                                            style={{ display: "none" }}
                                            disabled={isApproved}
                                        />
                                    </div>
                                </label>
                                {form.step_6_media.cover_image && (
                                    <div className="ml-3 small text-muted text-break" style={{ maxWidth: "300px" }}>
                                        URL: {form.step_6_media.cover_image}
                                    </div>
                                )}
                            </div>
                            {errors.cover_image && <div className="text-danger small mb-4">{errors.cover_image}</div>}
                        </Col>

                        <Col md={12} className="mt-3">
                            <Form.Label>Portfolio Images <span className="text-danger">*</span> (Min 5)</Form.Label>
                            <div className="d-flex flex-wrap mb-1">
                                {form.step_6_media.portfolio_images.map((url, index) => (
                                    <div key={index} className="mr-3 mb-3 position-relative border rounded" style={{ width: "100px", height: "100px", background: "#f8f9fa", borderColor: errors.portfolio_images ? '#dc3545' : '' }}>
                                        {url ? (
                                            <>
                                                <img
                                                    src={url}
                                                    alt={`Portfolio ${index + 1}`}
                                                    style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "4px" }}
                                                />
                                                <div
                                                    className="position-absolute"
                                                    style={{ top: "-8px", right: "-8px", background: "#f03e3e", color: "#fff", borderRadius: "50%", width: "20px", height: "20px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: "12px" }}
                                                    onClick={() => !isApproved && removePortfolioImage(index)}
                                                >
                                                    <FaTimes />
                                                </div>
                                            </>
                                        ) : (
                                            <label className="m-0 p-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ cursor: isApproved ? "default" : "pointer" }}>
                                                <div className="text-center text-muted">
                                                    <FaPlus />
                                                </div>
                                                <Form.Control
                                                    type="file"
                                                    onChange={(e) => {
                                                        if (isApproved) return;
                                                        handleFileUpload(e, "step_6_media", "portfolio_images", index);
                                                        if (errors.portfolio_images) setErrors(prev => ({ ...prev, portfolio_images: null }));
                                                    }}
                                                    accept="image/*"
                                                    style={{ display: "none" }}
                                                    disabled={isApproved}
                                                />
                                            </label>
                                        )}
                                    </div>
                                ))}

                                <label className="mb-3 d-flex align-items-center justify-content-center border rounded bg-light" style={{ width: "100px", height: "100px", cursor: isApproved ? "default" : "pointer", borderStyle: "dashed !important", borderColor: errors.portfolio_images ? '#dc3545' : '' }}>
                                    <div className="text-center text-primary">
                                        <FaCamera size={24} />
                                        <div className="small font-weight-bold">+ Bulk</div>
                                    </div>
                                    <Form.Control
                                        type="file"
                                        multiple
                                        onChange={(e) => {
                                            if (isApproved) return;
                                            handleMultipleFileUpload(e, "step_6_media", "portfolio_images");
                                            if (errors.portfolio_images) setErrors(prev => ({ ...prev, portfolio_images: null }));
                                        }}
                                        accept="image/*"
                                        style={{ display: "none" }}
                                        disabled={isApproved}
                                    />
                                </label>
                            </div>
                            {errors.portfolio_images && <div className="text-danger small mb-3">{errors.portfolio_images}</div>}
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Instagram URL</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="https://..."
                                    value={form.step_6_media.instagram_url}
                                    onChange={e => handleInput("step_6_media", "instagram_url", e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Facebook URL</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="https://..."
                                    value={form.step_6_media.facebook_url}
                                    onChange={e => handleInput("step_6_media", "facebook_url", e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12} className="mt-3">
                            <Form.Group>
                                <Form.Label>YouTube URL</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="https://www.youtube.com/user/..."
                                    value={form.step_6_media.youtube_url}
                                    onChange={e => handleInput("step_6_media", "youtube_url", e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12} className="mt-4">
                            <Form.Label className="font-weight-bold">Portfolio Videos</Form.Label>
                            {form.step_6_media.portfolio_videos.map((url, index) => (
                                <div key={index} className="d-flex align-items-center mb-2">
                                    <Form.Control
                                        type="text"
                                        placeholder="https://www.youtube.com/watch?v=..."
                                        value={url}
                                        disabled={isApproved}
                                        onChange={e => handlePortfolioVideoChange(index, e.target.value)}
                                    />
                                    {!isApproved && (
                                        <Button
                                            variant="outline-danger"
                                            className="ml-2"
                                            onClick={() => removePortfolioVideo(index)}
                                            style={{ padding: '0.375rem 0.75rem' }}
                                        >
                                            <FaTimes />
                                        </Button>
                                    )}
                                </div>
                            ))}
                            {!isApproved && (
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    className="mt-1"
                                    onClick={addPortfolioVideo}
                                >
                                    <FaPlus className="mr-1" /> Add Video URL
                                </Button>
                            )}
                        </Col>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Languages Supported</Form.Label>
                                <Select
                                    isMulti
                                    placeholder="Select Languages"
                                    options={[
                                        { value: "English", label: "English" },
                                        { value: "Hindi", label: "Hindi" },
                                        { value: "Kannada", label: "Kannada" },
                                        { value: "Tamil", label: "Tamil" },
                                        { value: "Telugu", label: "Telugu" },
                                        { value: 'Malayalam', label: 'Malayalam' },
                                        { value: 'Marathi', label: 'Marathi' }
                                    ]}
                                    value={form.step_6_media.languages.map(l => typeof l === 'string' ? { value: l, label: l } : l)}
                                    isDisabled={isApproved}
                                    onChange={(selected) => handleInput("step_6_media", "languages", selected)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                );
            case 6:
                return (
                    <Row>
                        <Col md={6} className="mt-3">
                            <Form.Group>
                                <Form.Label>Response Time <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={form.step_7_operations.response_time}
                                    isInvalid={!!errors.response_time}
                                    disabled={isApproved}
                                    onChange={e => {
                                        handleInput("step_7_operations", "response_time", e.target.value);
                                        if (errors.response_time) setErrors(prev => ({ ...prev, response_time: null }));
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{errors.response_time}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mt-3"><Form.Group><Form.Label>GMB URL</Form.Label><Form.Control type="text" value={form.step_7_operations.gmb_url} disabled={isApproved} onChange={e => handleInput("step_7_operations", "gmb_url", e.target.value)} /></Form.Group></Col>
                        <Col md={6} className="mt-3"><Form.Group><Form.Label>Availability</Form.Label><Form.Control type="text" value={form.step_7_operations.availability} disabled={isApproved} onChange={e => handleInput("step_7_operations", "availability", e.target.value)} /></Form.Group></Col>
                    </Row>
                );
            case 7:
                if (form.step_1_category.vendor_category === 'photography' || form.step_1_category.vendor_category === 'Photography') {
                    return (
                        <Row>
                            <Col md={6} className="mt-3"><Form.Group><Form.Label>Number of Photographers</Form.Label><Form.Control type="number" min="0" value={form.step_8_operations.photographer_count} disabled={isApproved} onChange={e => handleInput("step_8_operations", "photographer_count", Math.max(0, parseInt(e.target.value) || ""))} /></Form.Group></Col>
                            <Col md={6} className="d-flex align-items-center mt-3">
                                <Form.Group className="m-0">
                                    <Form.Check
                                        type="checkbox"
                                        label="Video Services Provided"
                                        checked={form.step_8_operations.video_services}
                                        disabled={isApproved}
                                        onChange={e => handleInput("step_8_operations", "video_services", e.target.checked)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6} className="mt-3">
                                <Form.Group>
                                    <Form.Label>Visual Styles</Form.Label>
                                    <Select
                                        isMulti
                                        placeholder="Select Styles"
                                        options={[
                                            { value: 'Traditional', label: 'Traditional' },
                                            { value: 'Candid', label: 'Candid' },
                                            { value: 'Cinematic', label: 'Cinematic' },
                                            { value: 'Documentary Style', label: 'Documentary Style' },
                                            { value: 'Artistic/Creative', label: 'Artistic/Creative' },
                                            { value: 'Black & White', label: 'Black & White' },
                                            { value: 'Vintage/Retro', label: 'Vintage/Retro' },
                                            { value: 'Fashion/Editorial', label: 'Fashion/Editorial' },
                                            { value: 'Minimalist/Modern', label: 'Minimalist/Modern' },
                                            { value: 'Drone/Aerial', label: 'Drone/Aerial' },
                                            { value: 'Highlight Reel', label: 'Highlight Reel' },
                                            { value: 'Pre/Post Wedding', label: 'Pre/Post Wedding' },
                                            { value: 'Outdoor Shooting', label: 'Outdoor Shooting' }
                                        ]}
                                        value={form.step_8_operations.photography_styles.map(s => typeof s === 'string' ? { value: s, label: s } : s)}
                                        isDisabled={isApproved}
                                        onChange={(selected) => handleInput("step_8_operations", "photography_styles", selected)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6} className="mt-3">
                                <Form.Group>
                                    <Form.Label>Album Quality/Type</Form.Label>
                                    <Select
                                        isMulti
                                        placeholder="Select Quality"
                                        options={[
                                            { value: "Standard", label: "Standard" },
                                            { value: "Premium", label: "Premium" },
                                            { value: "Luxury", label: "Luxury" }
                                        ]}
                                        value={form.step_8_operations.album_quality}
                                        isDisabled={isApproved}
                                        onChange={(selected) => handleInput("step_8_operations", "album_quality", selected)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6} className="d-flex align-items-center mt-3">
                                <Form.Group className="m-0">
                                    <Form.Check type="checkbox" label="Drone Photography" checked={form.step_8_operations.drone_photography} disabled={isApproved} onChange={e => handleInput("step_8_operations", "drone_photography", e.target.checked)} />
                                </Form.Group>
                            </Col>
                            <Col md={6} className="d-flex align-items-center mt-3">
                                <Form.Group className="m-0">
                                    <Form.Check type="checkbox" label="Raw Files Provided" checked={form.step_8_operations.raw_files_provided} disabled={isApproved} onChange={e => handleInput("step_8_operations", "raw_files_provided", e.target.checked)} />
                                </Form.Group>
                            </Col>
                            <Col md={6} className="mt-3"><Form.Group><Form.Label>Edit Turnaround Time (Days)</Form.Label><Form.Control type="number" min="0" value={form.step_8_operations.edit_turnaround_time} disabled={isApproved} onChange={e => handleInput("step_8_operations", "edit_turnaround_time", Math.max(0, parseInt(e.target.value) || ""))} /></Form.Group></Col>
                            <Col md={12} className="mt-3"><Form.Group><Form.Label>Special Packages/Offers</Form.Label><Form.Control as="textarea" rows={2} value={form.step_8_operations.special_packages} disabled={isApproved} onChange={e => handleInput("step_8_operations", "special_packages", e.target.value)} /></Form.Group></Col>
                        </Row>
                    );
                } else {
                    return (
                        <Row>
                            <Col md={12} className="mt-3">
                                <div className="text-center p-5">
                                    <h4 className="text-muted">Specific details for {form.step_1_category.vendor_category || 'this category'} are not configured yet.</h4>
                                </div>
                            </Col>
                        </Row>
                    );
                }
            case 8:
                return (
                    <Row>
                        <Col md={12} className="mt-3">
                            <Form.Group>
                                <Form.Label>Payment Terms <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Enter payment terms (e.g., 20% Advance, 70% on Event Day, 10% After Event)..."
                                    value={form.step_9_payment.payment_terms}
                                    isInvalid={!!errors.payment_terms}
                                    onChange={e => {
                                        handleInput("step_9_payment", "payment_terms", e.target.value);
                                        if (errors.payment_terms) setErrors(prev => ({ ...prev, payment_terms: null }));
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{errors.payment_terms}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                );
            case 9:
                return (
                    <Row>
                        <Col md={12} className="mt-3">
                            <Form.Group>
                                <Form.Label>About Us <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={5}
                                    placeholder="Tell us about your business..."
                                    value={form.step_5_service.service_description}
                                    isInvalid={!!errors.service_description}
                                    disabled={isApproved}
                                    onChange={e => {
                                        handleInput("step_5_service", "service_description", e.target.value);
                                        if (errors.service_description) setErrors(prev => ({ ...prev, service_description: null }));
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">{errors.service_description}</Form.Control.Feedback>
                            </Form.Group>
                            {!isApproved && (
                                <div className="mt-2">
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={autoGenerateAboutUs}
                                    >
                                        Auto-generate
                                    </Button>

                                </div>
                            )}
                        </Col>
                    </Row>
                );
            default:
                return "Unknown step";
        }
    };

    return (
        <Container className="vendor">
            <Row>
                <Col md={12} className="contBody">
                    <Card>
                        <CardBody className="theme-light">
                            <div className="card__title pageNav">
                                <Breadcrumbs data={breadcrumbData} />
                            </div>

                            <Loader loading={loading}>
                                <div className="mt-4">
                                    <Form>
                                        {isApproved && (
                                            <Alert variant="info" className="mb-4">
                                                This vendor profile has been approved and cannot be edited.
                                            </Alert>
                                        )}

                                        <div className="mb-5">
                                            <h5 className="mb-3 border-bottom pb-2 font-weight-bold">Category Selection</h5>
                                            {renderStepContent(0)}
                                        </div>

                                        <div className="mb-5">
                                            <h5 className="mb-3 border-bottom pb-2 font-weight-bold">Business Information</h5>
                                            {renderStepContent(1)}
                                        </div>

                                        <div className="mb-5">
                                            <h5 className="mb-3 border-bottom pb-2 font-weight-bold">Bank Details</h5>
                                            {renderStepContent(2)}
                                        </div>

                                        <div className="mb-5">
                                            <h5 className="mb-3 border-bottom pb-2 font-weight-bold">Location & Coverage</h5>
                                            {renderStepContent(3)}
                                        </div>

                                        <div className="mb-5">
                                            <h5 className="mb-3 border-bottom pb-2 font-weight-bold">Service Pricing</h5>
                                            {renderStepContent(4)}
                                        </div>

                                        <div className="mb-5">
                                            <h5 className="mb-3 border-bottom pb-2 font-weight-bold">Social & Media</h5>
                                            {renderStepContent(5)}
                                        </div>

                                        <div className="mb-5">
                                            <h5 className="mb-3 border-bottom pb-2 font-weight-bold">About Us</h5>
                                            {renderStepContent(9)}
                                        </div>

                                        <div className="mb-5">
                                            <h5 className="mb-3 border-bottom pb-2 font-weight-bold">Operations</h5>
                                            {renderStepContent(6)}
                                        </div>

                                        <div className="mb-5">
                                            <h5 className="mb-3 border-bottom pb-2 font-weight-bold">Specific Details</h5>
                                            {renderStepContent(7)}
                                        </div>

                                        <div className="mb-5">
                                            <h5 className="mb-3 border-bottom pb-2 font-weight-bold">Payment Terms</h5>
                                            {renderStepContent(8)}
                                        </div>

                                        <div className="mt-4 pt-3 border-top">
                                            <Col md={12} className="mt-4 mb-4 d-flex justify-content-end">
                                                <Button
                                                    variant="secondary"
                                                    className="mr-2"
                                                    onClick={() => history.push('/eventVendorList')}
                                                >
                                                    Cancel
                                                </Button>
                                                {!isApproved && (
                                                    <Button
                                                        variant="primary"
                                                        onClick={saveForm}
                                                        disabled={loading}
                                                    >
                                                        {loading ? "Saving..." : (editMode ? "Update Vendor" : "Submit")}
                                                    </Button>
                                                )}
                                            </Col>
                                        </div>
                                    </Form>
                                </div>
                            </Loader>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <ToastContainer />
        </Container>
    );
};

export default EventVendorForm;
